import {useEffect} from "react";

import {publishAnalyticsEventForMinorConversion} from "@khan/analytics-learning-time";

import {createEvent as createMathExpressionCopiedEvent} from "./math-expression-copied-event.ts";
import {selectionIntersectsNode} from "./selection.ts";

export function useCopyAnalytics(params: {
    tex: string;
    renderedDOMRef: {current: Nullable<HTMLElement>};
    renderer: "katex" | "mathjax2" | "mathjax3";
    contextForAnalytics: "ai-guide" | "content-library";
}) {
    const {tex, renderedDOMRef, renderer, contextForAnalytics} = params;
    useEffect(() => {
        function onCopy() {
            if (selectionIntersectsNode(renderedDOMRef.current)) {
                // We can't `useLocation` here, because this component gets used
                // in e.g. the exercise editor, where the necessary React
                // context isn't present.
                // eslint-disable-next-line no-restricted-syntax -- see above comment
                const url = window.location.href;
                publishAnalyticsEventForMinorConversion(
                    createMathExpressionCopiedEvent({
                        context: contextForAnalytics,
                        tex,
                        currentPageURL: url,
                        renderer,
                    }),
                );
            }
        }

        document.body.addEventListener("copy", onCopy);
        return () => document.body.removeEventListener("copy", onCopy);
    }, [tex, renderedDOMRef, contextForAnalytics, renderer]);
}
